export default {
  en: {
    top_email: 'support@mopubi.com',
    top_telegram: 'Https://t.me/joinchat/EHER6Q0FAGp1rNLajkldPA',
    top_faq: "telegram & | FQAs",
    features: 'Features',
    features_con1: 'Highly-recommended & most cost-effective Android VPN',
    features_con2: 'Securely browse & send messages, photos, etc',
    features_con3: 'Gigabit acceleration, unlimited bandwidth, lots of streaming and game servers',
    features_con4: 'Support for multi-devices online simultaneously',
    features_con5: '7-day money-back guarantee',
    features_btn: 'Get PlexVPN',
    steps: '3 simple steps to use PlexVPN on Android devices',
    steps_num1: '1. Install PlexVPN Android version on your phone or tablet.',
    steps_num2: '2. Sign in your account, and select your desired servers.',
    steps_num3: '3. Connect to the servers, then you can browse your favorite content quickly, safely and privately.',
    steps_btn: 'Download',
    main_features: 'Features of PlexVPN Android version',
    main_features_title1: 'Bypass GEO and copyright restrictions',
    main_features_con1: 'PlexVPN can help you easily access websites around the world, and the high-speed server ensures that you can watch your favorite contents smoothly without being restricted by copyright.',
    main_features_title2: 'Gigabit acceleration, unlimited bandwidth, stable and reliable',
    main_features_con2: 'With the advanced acceleration technology, users even can break through the bandwidth limit of carriers. Through our test, the download speed exceeds 1000Mb/s with connection latency of just a few tens of milliseconds. The best part is that PlexVPN doesn’t have traffic limit',
    main_features_title3: 'Servers all over the world',
    main_features_con3: 'PlexVPN provides high-quality servers all around the world, including Netflix, Disney+, Hulu, HBO, iPlayer and games servers. You can choose the server according to your needs.',
    main_features_title4: 'Data encryption, no logs',
    main_features_con4: 'We respect your privacy and protect your personal information. PlexVPN will help you hide the IP address of your Android devices. No one can track your message or location.',
    main_features_title5: 'Support for multi-platform devices',
    main_features_con5: 'PlexVPN has user-friendly clients for Android, iOS, MacOS, Ubuntu and Andorid TV devices. VIP members can enjoy the cross-platform use of mobile phones, tablets and computers.',
    main_features_title6: 'Friendly customer & technical support',
    main_features_con6: 'If you encountered any problems while using PlexVPN, or you have any suggestions or advices to us, you can contact our customer support team via online feedback in the APP.',
    reviews: 'Reviews from PlexVPN Android users',
    reviews_user1: 'Garikayi Mhizha',
    reviews_data1: '2020.06.17',
    reviews_con1: "\"This is an excellent app. It has the best servers, best customer service and surely the best reasonable prices for the great service they provide. I reccomend you download plex vpn for vpn. You won't regret your choice.\"",
    reviews_user2: 'Jesse Elizondo',
    reviews_data2: '2020.05.24',
    reviews_con2: '\"The Plex VPN works consistently well and is one of my favs.\"',
    reviews_user3: 'Camara Abou Mohamed',
    reviews_data3: '2019.03.21',
    reviews_con3: "\"I love plexVPN because of its best design colour .And it's develop others app including the profile e.t.c\"",
    reviews_user4: 'Ehsan Muhammad',
    reviews_data4: '2020.05.05',
    reviews_con4: "\"Dear vpn Developer, you are the best among all vpn Developers.. World's best vpn Plexvpn. G Hats off to you all the team..\"",
    reviews_user5: 'Kenneth Mugwanya',
    reviews_data5: '2019.05.14',
    reviews_con5: '\"Supper fast connection Speed VPN I liked it in the first installation. 5/5 stars. Highly recommended. Thanks developer Team.\"',
    reviews_user6: 'Nouman Nomi',
    reviews_data6: '2020.08.12',
    reviews_con6: '\"Its good vpn. I like this.very easy to connect and quickly response\"',
    faqs: 'FAQ for Android client',
    faqs_title1: 'Why do you need to use PlexVPN on Android device? ',
    faqs_con1: 'PlexVPN is a cost-effective, powerful & user-friendly VPN for Android devices. We have servers all over the world. High-speed video & game servers can help you visit you favorite contents quickly and stably, and hide the real IP address of your devices. Through the latest and strongest ECC technology, your data is fully protected, no one can monitor or steal your network data. As we all know, Android devices are vulnerable to malicious attacks, so it is necessary to use a VPN. Safety first!',
    faqs_title2: 'What happens without a VPN for Android devices?',
    faqs_con2: 'Without a VPN, some websites or software may not be available in some countries/regions. The Network operators and hackers can easily read and steal your information (such as emails, instant messages, web browsing history, etc.), and your Android device is also vulnerable to some malicious attacks. ',
    faqs_title3: 'Can PlexVPN be used on devices other than Android?',
    faqs_con3: 'Yes, PlexVPN support for cross-platform use. PlexVPN has user-friendly clients for Android, iOS, MacOS, Ubuntu and Andorid TV devices.',
    footer: 'PlexVPN focus on meeting your Internet needs, allowing you to visit your favorite websites safely and securely.'
  },
  zh: {
    features: '功能介绍',
    features_con1: '专家推荐 Android 性价比首选 VPN',
    features_con2: '安全地浏览, 发送短信和照片',
    features_con3: '千兆加速, 无限宽带及流量, 游戏视频专线',
    features_con4: '支持多台设备同时在线使用',
    features_con5: '7天退款保证',
    features_btn: '获取 PlexVPN',
    steps: '通过3个简单的步骤在 Android 上使用 PlexVPN',
    steps_num1: '1. 在手机或者平板电脑上下载并安装 Android 版的 PlexVPN 应用。',
    steps_num2: '2. 打开 PlexVPN，登陆您的账号，从线路列表中选择需要的线路并进行连接。',
    steps_num3: '3. 建立连接后，您就可以极速、安全、隐私地浏览喜欢的内容了。',
    steps_btn: '下载',
    main_features: '适用于 Android 应用程序的 PlexVPN 主要功能',
    main_features_title1: '突破地域、版权限制',
    main_features_con1: 'PlexVPN 可以随时随地帮您轻松访问任何国家的网站，高速线路确保您可以流畅地观看喜欢的内容，而不受版权地域的限制。',
    main_features_title2: '千兆加速，无限流量，稳定可靠',
    main_features_con2: 'PlexVPN 通过使用先进的加速技术，下载速度超过了1000Mb/s，连接延迟仅有几十毫秒，而且没有流量限制！',
    main_features_title3: '服务器覆盖全球',
    main_features_con3: 'PlexVPN 优质服务器遍布全球各地，还有 Netflix、Disney+、Hulu、HBO、iPlayer 及游戏等专线。您可以根据自己需求选择喜欢的线路进行连接。',
    main_features_title4: '数据加密，无日志',
    main_features_con4: '我们尊重并着重于保护您的个人隐私。PlexVPN 可以帮助您隐藏您 Android 设备的 IP 地址，任何人都无法查看您发送的信息或追踪您的位置。',
    main_features_title5: '设备兼容，一应俱全',
    main_features_con5: '不管操作系统是 Android、iOS、Window、MacOS，Ubuntu 还是 Android TV，PlexVPN 都拥有操作简便的客户端。VIP 可享受手机，平板，电脑跨平台使用！',
    main_features_title6: '友好的客服 & 技术支持',
    main_features_con6: '使用过程中遇到任何问题，或者您对 PlexVPN 有任何的意见或者建议，都可以通过客户端在线反馈联系我们。',
    reviews: '来自 PlexVPN Android 用户的评论',
    reviews_user1: 'AE chihiro',
    reviews_data1: '2020年6月17日',
    reviews_con1: '\“买了会员了，体验很好。在 PC上 看油管 4K 没问题，手机上我用被限速的 4G 照样流畅观看 720P。\”',
    reviews_user2: 'Uriah Cong',
    reviews_data2: '2020年05月24日',
    reviews_con2: '\“一直都好用！你们是支撑我在国内上网冲浪的精神支柱，请一定好好地做下去！24小时 VPN 没在怕的！\”',
    reviews_user3: 'Ava Lanche',
    reviews_data3: '2019年3月31日',
    reviews_con3: '\“速度比较稳定，价格也适中，客服也耐心，用了得两年了吧，希望能坚持下去！\”',
    reviews_user4: 'xingyu peng',
    reviews_data4: '2020年5月5日',
    reviews_con4: '\“速度真的很快，而且有活动，综合下来也不贵，关键是手机电脑都可以用，真的很好。\”',
    reviews_user5: 'yo moe',
    reviews_data5: '2019年5月14日',
    reviews_con5: '\“一直在用这个！感觉套餐价格比较能接受，而且连接很稳定，客服也是真的非常亲切耐心~加油＾０＾~\”',
    reviews_user6: 'NT.Tp.',
    reviews_data6: '2020年8月12日',
    reviews_con6: '\“一个美国的朋友推荐给我的，开了2个季度的会员。使用了大半年，挺好用，连接稳定没有广告。\”',
    faqs: '在 Android 设备上使用 PlexVPN 的常见问题',
    faqs_title1: '为什么需要在 Android 设备上使用 PlexVPN ？',
    faqs_con1: 'PlexVPN 是适用于 Android 设备的高性价比 VPN，功能强大，用户友好，在全球拥有大量服务器。高速视频游戏专线可以帮助您快速稳定地访问喜欢的内容，并隐藏您 Android 设备的 IP 地址。通过最新、最强的椭圆曲线加密技术，全方位保护您的数据安全，没有人能够监控或窃取您的网络数据。众所周知，Android 设备很容易遭到一些恶意攻击，所以使用 VPN 是非常有必要的。安全第一！',
    faqs_title2: '如果 Android 设备上不使用VPN会怎样？',
    faqs_con2: '如果没有 VPN，某些网站或软件可能在部分国家/地区无法使用。运营商、黑客能够轻易读取并窃取您的信息（例如电子邮件，即时消息，Web 浏览历史记录等等），你的 Android 设备也很容易遭到一些恶意攻击。',
    faqs_title3: 'PlexVPN 是否可以用于 Android 外的其他设备？',
    faqs_con3: '可以，PlexVPN  支持跨平台使用。不管操作系统是 Android、iOS、Window、MacOS，Ubuntu 还是 Android TV，PlexVPN 都拥有操作简便的客户端。',
    footer: 'PlexVPN 一直致力于满足您的上网需求，让您能够安全、放心地访问自己喜欢的网站，而没有任何后顾之忧'
  }
}


// WEBPACK FOOTER //
// ./src/views/promotion/lp/lang.js